import { createSliceContext } from "./CreateSliceContext";

interface GlobalAlertSliceProps {
  brand: { brand_code?: string };
}

const defaultGlobalAlertSliceValues: GlobalAlertSliceProps = {
  brand: { brand_code: "" },
};

export const {
  Provider: GlobalAlertSliceProvider,
  useContext: useGlobalAlertSliceContext,
} = createSliceContext<GlobalAlertSliceProps>(
  "GlobalAlert",
  defaultGlobalAlertSliceValues
);
